import React from 'react';

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  maxLength?: number;
  autoComplete?: string;
  /** Force direction, e.g. "ltr" for codes. */
  dir?: 'ltr' | 'rtl' | 'auto';
  className?: string;
}

const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  inputMode,
  maxLength,
  autoComplete = 'off',
  dir = 'auto',
  className = '',
}) => (
  <label className={`flex flex-col gap-1.5 text-sm ${className}`}>
    <span className="font-medium text-school-muted">{label}</span>
    <input
      value={value}
      placeholder={placeholder}
      inputMode={inputMode}
      maxLength={maxLength}
      autoComplete={autoComplete}
      dir={dir}
      onChange={(e: React.ChangeEvent<HTMLInputElement>): void => onChange(e.target.value)}
      className="min-h-[44px] rounded-xl border border-school-line bg-school-surface px-3 text-base text-school-ink placeholder:text-school-neutral focus:border-school-primary focus:outline-none focus:ring-2 focus:ring-school-primary-soft"
    />
  </label>
);

export default TextField;
